import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocale } from '../contexts/LocaleContext';
import { cartActions } from '../reducers/storeCart';
import * as types from '../types';

/**
 * Keeps the store cart priced in the locale's currency. The cart's currency is set when an
 * item is added and persists in localStorage, so a shopper who switches country afterwards
 * would otherwise check out a USD cart against a CA account and be rejected at purchase.
 * Hardcoded to the store cart: it runs at the app root, outside any route-driven cart mode.
 */
export default function useStoreCartCurrencySync(): void {
  const { currency } = useLocale();
  const cartCurrency = useSelector((state: types.AppState) => state.storeShop.cart.currency);
  const dispatch = useDispatch();

  useEffect(() => {
    if (cartCurrency !== currency) {
      dispatch(cartActions.setCurrency(currency));
    }
  }, [cartCurrency, currency, dispatch]);
}
